// extracted by mini-css-extract-plugin
module.exports = {"errorText":"ShopCartLink__errorText","darkBackground":"ShopCartLink__darkBackground"};